module.exports = __webpack_public_path__ + "static/img/dna.5252905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/dna.png
// module id = QtvT
// module chunks = 1 3